/**
 * Apollo cache
 */

const getDynamicUsersByRoleListPolicy = {
  keyArgs: ['search', 'roles'] as const,
};

export { getDynamicUsersByRoleListPolicy };
